import { useSelector } from 'react-redux';
import { useGetResolutionTypeQuery } from '../services/swarmsApi';
import { selectResolutionType } from '../store/slices/swarms';

export const useResolutionTypes = () => {
    const resolutionTypes = useSelector(selectResolutionType);
    const { data } = useGetResolutionTypeQuery(undefined, {
        // Solo hacer el request si no hay datos en el store
        skip: resolutionTypes && resolutionTypes.length > 0
    });

    return resolutionTypes || data || [];
};
